import { API_BASE_URL } from "../constant";

//  Auth
export const usersSignUp = (data) => API_BASE_URL.post("auth/register", data);

export const usersSignIn = (data) => API_BASE_URL.post("auth/login", data);
export const getUserById = () => API_BASE_URL.get("auth/user");

export const getCompanyUsers = (companyId) =>
  API_BASE_URL.get(`user/company/${companyId}`);

export const updateUser = (data, userId) =>
  API_BASE_URL.put(`user/${userId}`, data);

// export const getAllEmployee = (companyId) =>
//   API_BASE_URL.get(`users/get-all-employee/${companyId}`);

export const getAllEmployee = (companyId, page, limit) =>
  API_BASE_URL.get(`user/employee/${companyId}`, {
    params: { page, limit },
  });

export const getAllSupervisor = (companyId, page, limit) =>
  API_BASE_URL.get(`user/supervisor/${companyId}`, {
    params: { page, limit },
  });

export const deleteUser = (userId) =>
  API_BASE_URL.delete(`user/${userId}`);
